import { render } from "./UserGuide.vue?vue&type=template&id=04d8c004&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"

import "./UserGuide.vue?vue&type=style&index=0&id=04d8c004&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d8c004"]])

export default __exports__